import { useTranslation } from 'react-i18next'
import Button from '../ui/Button'
import RichText from '../ui/RichText'
import contentData from '../../data/content.json'

function TCTSYSection() {
  const { t } = useTranslation()

  const benefitsItems = t('pages.home.sections.tctsySection.benefits.items', { returnObjects: true })
  const targetItems = t('pages.home.sections.tctsySection.target.items', { returnObjects: true })

  return (
    <section id="tctsy" className="section-container bg-white py-80">
      <div className="content-wrapper">
        <h2 className="text-lato-bold text-[32px] mb-32">
          {t('pages.home.sections.tctsySection.heading')}
        </h2>

        {/* Two-column layout: Description left, Benefits right */}
        <div className="flex flex-col desktop:flex-row gap-32 desktop:gap-40">
          {/* Left column - Description */}
          <div className="desktop:w-1/2">
            <RichText
              text={t('pages.home.sections.tctsySection.description')}
              className="text-lato-regular mb-4"
            />
            <RichText
              text={t('pages.home.sections.tctsySection.benefits.intro')}
              className="text-lato-regular mb-4"
            />
          </div>

          {/* Right column - Benefits box */}
          <div className="desktop:w-1/2">
            <div className="bg-beige rounded-md p-24">
            <h3 className="text-lato-bold text-xl">
              {t('pages.home.sections.tctsySection.benefits.heading')}
            </h3>
  
            <ul className="space-y-12 mb-20">
              {benefitsItems.map((item, index) => (
                <li key={index} className="text-lato-regular flex items-start gap-12">
                  <span className="text-sage mt-1 flex-shrink-0">&#10003;</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <RichText
              text={t('pages.home.sections.tctsySection.benefits.outro')}
              className="text-lato-regular"
            />
          </div>
          </div>
        </div>

        {/* Target audience - Highlight box */}
        <div className="bg-sage/10 rounded-md p-24 desktop:p-32 mb-32 mt-15">
          <h3 className="text-lato-bold text-xl">
            {t('pages.home.sections.tctsySection.target.heading')}
          </h3>
          <div className="grid grid-cols-1 tablet:grid-cols-2 gap-15">
            {targetItems.map((item, index) => (
              <div key={index} className="text-lato-regular flex items-start gap-12">
                <span className="text-sage mt-1 flex-shrink-0">&#8594;</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Ending text */}
        <RichText
          text={t('pages.home.sections.tctsySection.ending')}
          className="text-lato-regular mb-32"
        />

        <Button
          href={contentData.contactForm.url}
          openInNewTab={contentData.contactForm.openInNewTab}
          className="max-w-[220px]"
        >
          {t('pages.home.sections.tctsySection.ctaButton.text')}
        </Button>
      </div>
    </section>
  )
}

export default TCTSYSection
